import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface SkeletonConfig {
  type: 'form' | 'card' | 'list' | 'table';
  count?: number;
  animation?: 'pulse' | 'wave';
  height?: string;
}

@Component({
  selector: 'app-skeleton-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss'
})
export class SkeletonLoaderComponent {
  config = input.required<SkeletonConfig>();
  
  items = computed(() => Array(this.config().count || 3).fill(0));
  
  getSkeletonClass(): string {
    const cfg = this.config();
    const classes = ['skeleton-item', `skeleton-${cfg.type}`];
    
    if (cfg.animation) {
      classes.push(`skeleton-${cfg.animation}`);
    }
    
    return classes.join(' ');
  }
  
  getSkeletonStyle(): { [key: string]: string } {
    const cfg = this.config();
    const style: { [key: string]: string } = {};
    
    if (cfg.height) {
      style['height'] = cfg.height;
    }
    
    return style;
  }
}
